import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import brandUpdaters, {UpdateBrandPayload} from '@/api/updaters/brand';

function useUpdateBrand(agencyId: string) {
  return useMutation({
    mutationKey: ['brand', 'update'],
    mutationFn: ({
      brandId,
      data,
    }: {
      brandId: string;
      data: UpdateBrandPayload;
    }) => brandUpdaters.updateBrand({agencyId, brandId, data}),
    onSuccess: () => {
      queryClient.invalidateQueries(['organizationBrands']);
    },
  });
}

export default useUpdateBrand;
